import TableData from './TableData';
export default TableData;